<template>
  <div class="hero">
    <div class="first">
      <h1>BTA Hammocks</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "Hero",
};
</script>

<style>
.hero {
  position: relative;
  padding-bottom: 70.8333333%;
  /* height: 600px; */
  background: url("/hero-styled.png") no-repeat center;
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
}

.first {
  position: absolute;
  width: 100%;
  text-align: center;
  top: auto;
  bottom: 39%;
}

.first h1 {
  color: black;
  font-size: 50px;
  line-height: 60px;
  /* margin-bottom: 14px; */
  line-height: 1.2;
  font-weight: 600;
  letter-spacing: 0.75px;
  text-shadow: 1px 1px 2px grey;
  text-align: center;
}

.first p {
  color: white;
  margin-top: 15px;
  font-size: 35px;
  line-height: 26px;
  font-family: "Trirong", serif;
  font-weight: 300;
  letter-spacing: 0.5px;
  text-shadow: 1px 1px 2px grey;
  text-align: center;
}
</style>
